import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

export default class NavigationLink extends Component {

	render() {
		const renderClass = this.props.brand ? 'navigation-link navigation-brand' : 'link';
		return (
			<li data-toggle="collapse" data-target="#main-nav.in">
				<NavLink {...this.props} className={renderClass} activeClassName='active'>
					<i className={`${this.props.icon} navigation-icon`} />
					<span>{this.props.title}</span>
				</NavLink>
			</li>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/navigationLink.js